import { IconButton, TextField } from '@mui/material';
import styled from 'styled-components';
import { media } from '../../theme/breakpoints';
import theme from '../../theme/theme';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const StyledForm = styled.form<{ $hasFile: boolean; $isMultiLine: boolean; $isDraggingOver?: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    border: 1px solid ${(props) => (props.$isDraggingOver ? 'rgba(4, 47, 152, 0.5)' : 'rgba(224, 224, 224, 1)')};
    border-radius: 16px;
    background: ${(props) => (props.$isDraggingOver ? 'rgba(4, 47, 152, 0.05)' : '#ffffff')};
    padding: ${(props) => (props.$hasFile ? '14px' : '12px')};
    transition: all 0.2s ease-in-out;

    @media (max-width: 600px) {
        padding: 5px;
    }

    ${media.sm} {
        padding: ${(props) => (props.$hasFile ? '12px' : '10px')};
    }

    ${media.md} {
        padding: ${(props) => (props.$hasFile ? '11px' : '8px')};
    }
`;

export const MicrophoneButton = styled(IconButton)<{ $isRecording: boolean }>`
    color: ${(props) => (props.$isRecording ? 'red' : theme.palette.primary.main) + ' !important'};
    width: 36px;
    height: 36px;
    padding: 5px !important;

    &:hover:not(:disabled) {
        background: rgba(224, 221, 222, 0.5) !important;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    svg {
        width: 20px;
        height: 20px;
    }

    ${media.sm} {
        width: 32px;
        height: 32px;
    }
`

export const GlobeButton = styled(IconButton)<{ $isInternetSelected: boolean }>`
    background-color: ${(props) => (props.$isInternetSelected ? 'rgba(0, 0, 0, 0.1) !important' : 'transparent !important')};
    width: 36px;
    height: 36px;
    padding: 5px !important;

    &:hover:not(:disabled) {
        background: rgba(224, 221, 222, 0.5) !important;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    svg {
        width: 20px;
        height: 20px;
        
        path {
            stroke: ${theme.palette.primary.main};
        }
    }

    ${media.sm} {
        width: 32px;
        height: 32px;
    }
`;

export const InputActions = styled.div<{ $attachedFile: boolean; $isMultiLine: boolean }>`
    display: flex;
    align-items: center;
    gap: 4px;
    position: relative;
    bottom: 3px;

    @media (max-width: 600px) {
        gap: 1px;
    }

    ${media.sm} {
        gap: 2px;
    }

    label {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        cursor: pointer;

        &:hover:not([style*="opacity: 0.5"]) {
            background: rgba(224, 221, 222, 0.5);
        }

        button {
            width: 36px;
            height: 36px;
            padding: 5px;

            svg {
                width: 20px;
                height: 20px;
            }
        }

        ${media.sm} {
            width: 32px;
            height: 32px;

            button {
                width: 32px;
                height: 32px;
            }
        }
    }
`;

export const InputWrapper = styled.div`
    display: flex;
    width: 100%;
    align-items: flex-end;
`;

export const ActionsWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`;

export const SendButtonWrapper = styled.div`
    display: flex;
    align-items: center;

    button {
        width: 42px;
        height: 42px;
        padding: 0;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            background: rgba(224, 221, 222, 0.5);
        }

        &:disabled {
            opacity: 0.45;
            pointer-events: none;
        }

        svg {
            path {
                stroke: ${theme.palette.primary.main};
            }
        }

        ${media.sm} {
            width: 37px;
            height: 37px;
        }
    }
`;

export const FileInfoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 8px 12px;
    width: max-content;
    margin-top: 10px;
    gap: 8px;
`;

export const RemoveButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    color: ${theme.palette.primary.main};
    padding: 0 4px;
    line-height: 1;

    &::after {
        content: '✕';
    }
`;

export const AttachmentOuterWrapper = styled.div`
    width: 100%;
    order: -1;
    margin-bottom: 8px;
    gap: 4px;
    display: flex;
    flex-wrap: wrap;
`;

export const FileInfoContainer = styled.div`
    display: inline-flex;
    align-items: center;
    background-color: #ffffff;
    color: ${theme.palette.text.primary};
    border-radius: 16px;
    padding: 6px 12px;
    gap: 8px;
    max-width: 100%;
    min-width: 40px;
    border: 1px solid rgba(224, 224, 224, 1);
    box-sizing: border-box;

    ${media.sm} {
        max-width: 80%;
    }
`;

export const FileIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.palette.primary.main};
    padding: 6px;
    border-radius: 8px;

    svg {
        path {
            stroke: white;
        }

        width: 24px;
        height: 24px;
    }
`;

export const FileName = styled.span`
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 72%;
    flex-grow: 1;

    ${media.sm} {
        font-size: 14px;
    }
`;

export const FileExtension = styled.span`
    font-size: 12px;
    text-transform: uppercase;
    margin-left: 4px;
    opacity: 0.8;
`;

export const StyledTextField = styled(TextField)<{ $hasFile: boolean }>`
    && {
        flex: 1;
        border: none;
        width: 100%;
        margin-left: 8px;

        .MuiOutlinedInput-root {
            border: none;
            font-size: 15px;
            padding: 8px 8px 8px 0px;
            position: relative;
            align-items: flex-end;
        }

        .MuiOutlinedInput-notchedOutline {
            display: none;
        }

        .MuiInputBase-input {
            padding: 0;
            line-height: 1.5;

            &::placeholder {
                color: rgba(0, 0, 0, 0.38);
                opacity: 1;
            }
        }

        ${media.sm} {
            .MuiOutlinedInput-root {
                font-size: 16px;
            }
        }
    }
`;

export const FileTextInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 75px;
`;

export const CharacterCounter = styled.div`
    align-self: flex-end;
    margin-top: 4px;
    margin-right: 8px;
    font-size: 12px;
    color: #666;
`;
